import { Button, createStyles, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import useLandingFunctions from "../../../../hooks/useLandingFunctions";
import { PFXMainComponent } from "../../../../models/Interfaces";
import {
  BUTTON_FONTSIZE_BASE,
  BUTTON_PADD_BASE,
  MARGIN_BASE,
  TITLE_FONTSIZE_BASE,
  DESKTOP_TEXT_MULTIPLIER,
} from "../../../../pages/Landing";
import { selectCompany, selectIsMobile } from "../../../../redux/slices/cleverlynkSlice";
import { selectComponentDimensions, selectMainComponent } from "../../../../redux/slices/landingSlice";
import { selectDisableNavbarFade } from "../../../../redux/slices/templateSlice";
import Logo from "../components/Logo";

interface IMainBasic extends PFXMainComponent {}

const MainBasic = ({
  backgroundColor,
  backgroundImage,
  button,
  logo,
  margins,
  opaqueBackground,
  title,
  type,
  verticalAlignment,
}: IMainBasic) => {
  const { height, width } = useSelector(selectComponentDimensions);
  const company = useSelector(selectCompany);
  const disableNavbarFade = useSelector(selectDisableNavbarFade);
  const isMobile = useSelector(selectIsMobile);

  const { handleGoToCatalog } = useLandingFunctions();

  const componentStyles = useMemo(
    () => ({
      title: {
        fontSize: `${
          (title?.fontSizeMultiplier ?? 1 * TITLE_FONTSIZE_BASE) * (isMobile ? 1 : DESKTOP_TEXT_MULTIPLIER)
        }rem`,
        color: title?.color ?? "#1a1a1a",
        textAlign: (title?.alignment ?? "center") as any,
        fontWeight: title?.fontWeight as any,
        fontFamily: title?.fontFamily,
      },
      button: {
        backgroundColor: button?.backgroundColor,
        color: button?.text?.color ?? "#1a1a1a",
        borderRadius: button?.borderRadius,
        padding: (button?.sizeMultiplier ?? 1) * BUTTON_PADD_BASE,
        height: 1,
        fontSize: `${button?.text?.fontSizeMultiplier ?? 1 * BUTTON_FONTSIZE_BASE}rem`,
        fontWeight: button?.text?.fontWeight as any,
        fontFamily: button?.text?.fontFamily,
      },
    }),
    [title, button, isMobile]
  );

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        height: isMobile ? height : height * 1.2,
        marginTop: disableNavbarFade ? 54 : 0,
        transition: "height 400ms",
        backgroundColor: backgroundColor ?? "#f7f7f7f7",
        backgroundImage: backgroundImage !== "" ? `url(${backgroundImage})` : undefined,
        backgroundPosition: "center top",
        backgroundSize: isMobile ? "cover" : "contain",
        backgroundRepeatY: "no-repeat",
        padding: `${(margins?.y ?? 2) * MARGIN_BASE}px ${(margins?.x ?? 2) * MARGIN_BASE}px`,
        position: "relative",
      },
      opaqueDiv: {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: !!opaqueBackground ? `${opaqueBackground.color}${opaqueBackground.alpha}` : undefined,
        zIndex: 1,
      },
      title: { ...componentStyles.title },
      button: {
        ...componentStyles.button,
        backgroundColor: componentStyles.button.backgroundColor,
        "&:hover": {
          backgroundColor: `${componentStyles.button.backgroundColor}8c`,
        },
        textTransform: "none",
      },
      buttonDiv: {
        marginTop: 20,
        width: "100%",
        borderRadius: 5,
        zIndex: 2,
      },
      buttonLabel: {
        fontFamily: componentStyles.button.fontFamily,
        fontSize: componentStyles.button.fontSize,
        fontWeight: componentStyles.button.fontWeight,
      },
      titleDiv: {
        width: "100%",
        borderRadius: 5,
        marginTop: 20,
        zIndex: 2,
      },
      content: {
        width,
      },
    })
  );

  const classes = useStyles();

  return (
    <Grid container justifyContent="center" className={classes.root}>
      <Grid
        container
        direction="column"
        className={classes.content}
        alignItems="center"
        justifyContent={verticalAlignment as any}>
        <div className={classes.opaqueDiv}></div>
        <Logo logo={logo as any} url={company?.logoUrl ?? ""} />
        <Grid
          item
          className={classes.titleDiv}
          id={`ttl-main-div`}
          // onClick={e => toggleAnchorElem(e, `title-${id}`, component.data?.title?.content)}
        >
          <Typography className={classes.title}>{title?.content}</Typography>
        </Grid>
        <Grid
          item
          className={classes.buttonDiv}
          id={`button-main-div`}
          container
          justifyContent="center"
          alignItems="center">
          <Button
            className={classes.button}
            classes={{ label: classes.buttonLabel }}
            onClick={() => handleGoToCatalog()}>
            {button?.text?.content}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default MainBasic;
